<template>
  <v-img src="" class="background-display">
  <v-container fluid class="px-1">
      <v-card width="400" class="mx-auto mt-5">
        <v-toolbar dark color="#00b2bb">
          <h2 class="ma-5 headline font-weight-thin">Cambio Exitoso</h2>
        </v-toolbar>
        <v-card-text>
          <div class="text-center">
              <p class="title-size mt-5">El cambio de contraseña ha sido exitoso</p>
            </div>
            <v-row>
              <template>
              <v-row class="mb-5 mx-5 justify-center" cols="12" xs="6" md="4" lg="4">
                <template >
                  <v-btn color="#00b2bb" dark @click="handleSubmit" style="margin-top: 40px;"
                  >Continuar</v-btn>
                </template>
              </v-row>
              </template>
            </v-row>
        </v-card-text>
      </v-card>
  </v-container>
  </v-img>
</template>
<style>
.title-size {
  font-size: 1.25em;
}
.background-display {
  background-color: #f5f5f5 !important;
  width: auto;
  min-height: 100%;
}
</style>
<script>
// @ is an alias to /src
/* import cost1 from '@/mock/cost1.json' */

export default {
  name: 'SignUpMessage',
  components: {
  },
  data () {
    return {
      titulo: ''
    }
  },
  methods: {
    handleSubmit () {
      this.$router.push({ path: '/' })
    }
  }
}
</script>
